import React from "react";
import classes from "./scss/GfeToggle.module.scss";
import { CircularProgress } from "../../../../../shared/CircularProgress/CircularProgress";
import { useToggleGfeOnFile } from "./hooks/useToggleGfeOnFile";
import { useContext } from "../../widgets/ModalAppointmentDetails/Appointment/context";

const GfeToggle = ({ refetchAppointments: refetchAllAppointments }) => {
  const { mutate, isLoading } = useToggleGfeOnFile();
  const { appointment, refetchAppointment, gfeToggle } = useContext();

  const handleToggle = () => {
    gfeToggle.setValue(!gfeToggle.value);
    refetchAppointment();
    refetchAllAppointments();
  };

  const handleChange = () => {
    const appointmentId = appointment.id;
    mutate(
      {
        appointmentId,
        gfeOnFile: !gfeToggle.value,
      },
      {
        onSuccess: () => handleToggle(),
      },
    );
  };

  return (
    <div>
      <span className={classes.toggleLabel}>GFE On File</span>
      <span>
        <label className="setting-switch pull-right flex" htmlFor="gfeToggle">
          {gfeToggle.value ? (
            <span className="radioTextLabel">Yes</span>
          ) : (
            <span className="radioTextLabel">No</span>
          )}
          <input
            type="checkbox"
            name="gfeToggle"
            id="gfeToggle"
            checked={Boolean(gfeToggle.value)}
            onChange={handleChange}
          />
          {!isLoading ? (
            <span className="setting-slider width-45"></span>
          ) : (
            <CircularProgress size="small" color="primary" />
          )}
        </label>
      </span>
    </div>
  );
};

export default GfeToggle;
